import callWebService, { callTypes } from "services/utils/networks/network";
import Config from "services/config/config";
import { B2B_DROPDOWN } from "./type";

export const getDropDownData = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postB2bAlliance.dropdownValues}${id}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    const data = payload?.data ?? outer?.data;
    dispatch({ type: B2B_DROPDOWN, payload: data });
    return data;
  } else {
    return null;
  }
};

export const submitB2bData = (allianceData) => async () => {
  const res = await callWebService(
    callTypes.post,
    allianceData,
    Config.postB2bAlliance.addPostAlliance
  );
  if (res) {
  } else {
    return null;
  }
};
